import $store from '@/store'
import { DataSyncRefNoBase } from '@/class/model/DataSyncRefNoBase'

export class InquiryPrice extends DataSyncRefNoBase {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'InquiryPrice'
  }

  get type() {
    return this._data.type
  }

  set type(type) {
    this._data.type = type || 0
  }

  get status() {
    return this._data.status
  }

  set status(status) {
    this._data.status = status || 1
  }

  get trunkLineEnable() {
    return this._data.trunkLineEnable
  }

  set trunkLineEnable(trunkLineEnable) {
    this._data.trunkLineEnable = trunkLineEnable || true
  }

  get prePortEnable() {
    return this._data.prePortEnable
  }

  set prePortEnable(prePortEnable) {
    this._data.prePortEnable = prePortEnable || false
  }

  get lastMileEnable() {
    return this._data.lastMileEnable
  }

  set lastMileEnable(lastMileEnable) {
    this._data.lastMileEnable = lastMileEnable || false
  }

  get inquiryPriceNo() {
    return this._data.inquiryPriceNo
  }

  set inquiryPriceNo(inquiryPriceNo) {
    this._data.inquiryPriceNo = inquiryPriceNo || ''
  }

  get source() {
    return this._data.source
  }

  set source(source) {
    this._data.source = source || 1
  }

  get seaEq() {
    return this._data.seaEq
  }

  set seaEq(seaEq) {
    this._data.seaEq = seaEq || ''
  }

  get cargoReadyTimeType() {
    return this._data.cargoReadyTimeType
  }

  set cargoReadyTimeType(cargoReadyTimeType) {
    this._data.cargoReadyTimeType = cargoReadyTimeType || 'range'
  }

  get cargoReadyTimeRange() {
    return this._data.cargoReadyTimeRange
  }

  set cargoReadyTimeRange(cargoReadyTimeRange) {
    this._data.cargoReadyTimeRange = cargoReadyTimeRange || 2
  }

  get cargoReadyTimeDate() {
    return this._data.cargoReadyTimeDate
  }

  set cargoReadyTimeDate(cargoReadyTimeDate) {
    this._data.cargoReadyTimeDate = cargoReadyTimeDate
  }

  get palletNature() {
    return this._data.palletNature
  }

  set palletNature(palletNature) {
    this._data.palletNature = palletNature || 1
  }

  get carrierId() {
    return this._data.carrierId
  }

  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }

  get directTransit() {
    return this._data.directTransit
  }

  set directTransit(directTransit) {
    this._data.directTransit = directTransit || 1
  }

  get commerceCode() {
    return this._data.commerceCode
  }

  set commerceCode(commerceCode) {
    this._data.commerceCode = commerceCode || ''
  }

  get pol() {
    return this._data.pol
  }

  set pol(pol) {
    this._data.pol = pol || ''
  }

  get pod() {
    return this._data.pod
  }

  set pod(pod) {
    this._data.pod = pod || ''
  }

  get transferPortCode() {
    return this._data.transferPortCode
  }

  set transferPortCode(transferPortCode) {
    this._data.transferPortCode = transferPortCode || ''
  }

  get cargoDescription() {
    return this._data.cargoDescription
  }

  set cargoDescription(cargoDescription) {
    this._data.cargoDescription = cargoDescription || ''
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }

  get submitDate() {
    return this._data.submitDate
  }

  set submitDate(submitDate) {
    this._data.submitDate = submitDate
  }

  get weight() {
    return this._data.weight
  }

  set weight(weight) {
    this._data.weight = weight || 0.0
  }

  get cubage() {
    return this._data.cubage
  }

  set cubage(cubage) {
    this._data.cubage = cubage || 0.0
  }

  get loadCargoType() {
    return this._data.loadCargoType
  }

  set loadCargoType(loadCargoType) {
    this._data.loadCargoType = loadCargoType || 0
  }

  get cargoType() {
    return this._data.cargoType
  }

  set cargoType(cargoType) {
    this._data.cargoType = cargoType || ''
  }

  get dangerousGoodsLevel() {
    return this._data.dangerousGoodsLevel
  }

  set dangerousGoodsLevel(dangerousGoodsLevel) {
    this._data.dangerousGoodsLevel = dangerousGoodsLevel || 0
  }

  get unNo() {
    return this._data.unNo
  }

  set unNo(unNo) {
    this._data.unNo = unNo || 0
  }

  get length() {
    return this._data.length
  }

  set length(length) {
    this._data.length = length || 0.0
  }

  get width() {
    return this._data.width
  }

  set width(width) {
    this._data.width = width || 0.0
  }

  get height() {
    return this._data.height
  }

  set height(height) {
    this._data.height = height || 0.0
  }

  get temperature() {
    return this._data.temperature
  }

  set temperature(temperature) {
    this._data.temperature = temperature || 0.0
  }

  get ventilationQuantity() {
    return this._data.ventilationQuantity
  }

  set ventilationQuantity(ventilationQuantity) {
    this._data.ventilationQuantity = ventilationQuantity || 0.0
  }

  get serviceTerm() {
    return this._data.serviceTerm
  }

  set serviceTerm(serviceTerm) {
    this._data.serviceTerm = serviceTerm || ''
  }

  get customerIdType() {
    return this._data.customerIdType
  }

  set customerIdType(customerIdType) {
    this._data.customerIdType = customerIdType || 1
  }

  get customerId() {
    return this._data.customerId
  }

  set customerId(customerId) {
    this._data.customerId = customerId || ''
  }

  get transportMode() {
    return this._data.transportMode
  }

  set transportMode(transportMode) {
    this._data.transportMode = transportMode || 1
  }

  get branchLine() {
    return this._data.branchLine
  }

  set branchLine(branchLine) {
    this._data.branchLine = branchLine || 0
  }

  get deliveryAddressType() {
    return this._data.deliveryAddressType
  }

  set deliveryAddressType(deliveryAddressType) {
    this._data.deliveryAddressType = deliveryAddressType || 1
  }

  get postalCode() {
    return this._data.postalCode
  }

  set postalCode(postalCode) {
    this._data.postalCode = postalCode || ''
  }

  get address() {
    return this._data.address
  }

  set address(address) {
    this._data.address = address || ''
  }

  get detailAddress() {
    return this._data.detailAddress
  }

  set detailAddress(detailAddress) {
    this._data.detailAddress = detailAddress || ''
  }

  get warehouseCode() {
    return this._data.warehouseCode
  }

  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode
  }

  get country() {
    return this._data.country
  }

  set country(country) {
    this._data.country = country || 'CN'
  }

  get province() {
    return this._data.province
  }

  set province(province) {
    this._data.province = province || ''
  }

  get city() {
    return this._data.city
  }

  set city(city) {
    this._data.city = city || ''
  }

  get districts() {
    return this._data.districts
  }

  set districts(districts) {
    this._data.districts = districts || ''
  }

  get townUuid() {
    return this._data.townUuid
  }

  set townUuid(townUuid) {
    this._data.townUuid = townUuid || ''
  }

  get salesOffice() {
    return this._data.salesOffice
  }

  set salesOffice(salesOffice) {
    this._data.salesOffice = salesOffice || $store.getters.currentOfficeId
  }

  get salesDepartment() {
    return this._data.salesDepartment
  }

  set salesDepartment(salesDepartment) {
    this._data.salesDepartment = salesDepartment || $store.getters.currentDeptId
  }

  get seaEqList() {
    return this._data.seaEqList
  }
  set seaEqList(seaEqList) {
    this._data.seaEqList = seaEqList || [{ quantity: 1, type: '' }]
  }

  get trunkLinePersonUserId() {
    return this._data.trunkLinePersonUserId
  }
  set trunkLinePersonUserId(trunkLinePersonUserId) {
    this._data.trunkLinePersonUserId = trunkLinePersonUserId || 0
  }

  get prePortPersonUserId() {
    return this._data.prePortPersonUserId
  }
  set prePortPersonUserId(prePortPersonUserId) {
    this._data.prePortPersonUserId = prePortPersonUserId || 0
  }

  get lastMilePersonUserId() {
    return this._data.lastMilePersonUserId
  }
  set lastMilePersonUserId(lastMilePersonUserId) {
    this._data.lastMilePersonUserId = lastMilePersonUserId || 0
  }
}
